import React, {useCallback, useEffect, useState} from 'react';
import {Prompt} from 'react-router-dom';
import {ConfirmMessageModal} from "../components/style-guide/modal";

const RouteLeavingGuard = ({when, navigate, shouldBlockNavigation}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [lastLocation, setLastLocation] = useState(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const closeModal = useCallback(
    () => {
      setModalVisible(false);
    },
    [setModalVisible],
  );

  const handleBlockedNavigation = (nextLocation) => {
    if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
      setModalVisible(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };

  const handleConfirmNavigationClick = () => {
    setModalVisible(false);
    setConfirmedNavigation(true);
  };

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with your navigate function
      navigate(lastLocation.pathname);
    }
  }, [confirmedNavigation, lastLocation, navigate]);

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation}/>

      <ConfirmMessageModal
        show={modalVisible}
        onClose={closeModal}
        onConfirm={handleConfirmNavigationClick}/>
    </>
  );
};

export default RouteLeavingGuard;